import React from 'react';
import PropTypes from 'prop-types';
import { Container, Icon } from './MaintenanceNotice.styles';

const MaintenanceNotice = ({ message }) => (
  <Container>
    <Icon className="mdi mdi-alert-circle-outline" />
    {message}
  </Container>
);

MaintenanceNotice.propTypes = {
  message: PropTypes.string.isRequired,
};

export default MaintenanceNotice;
